import { render, staticRenderFns } from "./OrdiniMTMList.vue?vue&type=template&id=cacae850"
import script from "./OrdiniMTMList.vue?vue&type=script&lang=ts"
export * from "./OrdiniMTMList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cacae850')) {
      api.createRecord('cacae850', component.options)
    } else {
      api.reload('cacae850', component.options)
    }
    module.hot.accept("./OrdiniMTMList.vue?vue&type=template&id=cacae850", function () {
      api.rerender('cacae850', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/OrdiniMTMList.vue"
export default component.exports